export default class TexsController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$uibModal,
		registresService,
		PaginationService,
		dapService,
		notification,
		$translate,
		moment,
		ModalService,
		globalizationManagementService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.moment = moment;
		this.ModalService = ModalService;
		this.registresService = registresService;
		this.PaginationService = PaginationService;
		this.DapService = dapService;
		this.loaded = true;
		this.sens = 0; // 0 = IN, 1 = OUT
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.declarationRndts = [];
		this.nomenclatures = [];
		this.nomenclaturesAllowed = [];
		this.societes = [];
		this.sites = [];
		this.clients = [];
		this.idClients = [];
		this.unregister = [];
		this.loading = false;
		this.lastSens = this.sens;
		this.listLinkedDap = [];
	}

	async $onInit() {
		await this.loadSocietes();
		await this.loadClients();
		this.unregister.push(
			this.$scope.$watch(
				() => this.idSociete,
				() => {
					if (this.idSociete && this.idSociete > 0) {
						this.declarationRndts = [];
						this.sites = [];
						this.idSite = null;
						this.loadSitesBySocieteId(this.idSociete);
					}
				},
				true
			)
		);

		await this.loadNomenclatures();
	}

	async getDapGeoVerification(bool) {
		var res = await this.registresService.verifyDapGeoLoc(
			this.idSociete,
			this.dateDebut,
			this.dateFin,
			this.idSite,
			this.nomenclatures.filter((x) => x.selected).map((x) => x.id),
			bool
		);

		this.$uibModal.open({
			animation: true,
			component: 'dapGeoLocFixCallback',
			size: 'lg',
			resolve: {
				result: () => {
					return res;
				}
			}
		});
	}

	async $doCheck() {
		if (this.lastSens != this.sens) {
			this.lastSens = this.sens;
			this.declarationRndts = [];
		}
	}

	async loadNomenclatures() {
		try {
			const [n, na] = await Promise.all([this.registresService.getNomenclatures(), this.registresService.getNomenclaturesAutorisee()]);
			console.log(n, na);
			this.nomenclatures = n?.data?.items ?? [];
			this.nomenclaturesAllowed = na?.data ?? [];

			console.log(this.nomenclatures, this.nomenclaturesAllowed);

			const allowedCodes = new Set(this.nomenclaturesAllowed.map((nom) => nom.code));

			this.nomenclatures = this.nomenclatures.filter((x) => allowedCodes.has(x.code));
			this.nomenclatures.forEach((nom) => {
				nom.selected = allowedCodes.has(nom.code);
			});
			console.log('Nomenclature selected on load');
			console.log(this.nomenclatures.filter((x) => x.selected).map((x) => x.id));
		} catch (error) {
			console.error('Error loading nomenclatures:', error);
			this.nomenclatures = [];
			this.nomenclaturesAllowed = [];
		}
	}

	async nomenclaturesUpdate(data) {
		console.log(data);
	}

	async loadSocietes() {
		try {
			this.societes = await this.registresService.getSocietes();
			if (this.societes.length == 1) {
				this.idSociete = this.societes[0].id;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}
	async loadSitesBySocieteId(idSociete) {
		try {
			this.sites = await this.registresService.getSitesBySocieteId(idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadClients() {
		try {
			this.clients = await this.registresService.getClients();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async click() {
		let t = await this.registresService.getTexsEntrants(1, '2024-01-01 00:00', '2025-04-30 00:00');
		console.log(t);
	}

	load(bool) {
		this.loading = bool;
	}

	printDeclarationRndts = async () => {
		console.log('ASK FOR DATA');
		console.log(this.dateDebut, this.dateFin, this.idSociete, this.sens);
		if (this.dateDebut && this.dateFin && this.idSociete) {
			var res = null;
			console.log('Selected nomenclatures on get');
			console.log(this.nomenclatures.filter((x) => x.selected).map((x) => x.id));
			try {
				if (this.sens == 0) {
					res = await this.registresService.printTexsEntrants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id)
					);
				} else if (this.sens == 1) {
					res = await this.registresService.printTexsSortants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id)
					);
				}

				if (res) {
					const data = res.data;
					let headers = res.headers;
					headers = headers();

					const contentType = headers['content-type'];

					const linkElement = document.createElement('a');
					try {
						const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
						const url = window.URL.createObjectURL(blob);
						linkElement.setAttribute('href', url);
						linkElement.setAttribute(
							'download',
							`export_texs_${this.sens == 0 ? 'entrants' : 'sortants'}_${this.dateDebut}_${this.dateFin}.xlsx`
						);

						const clickEvent = new MouseEvent('click', {
							view: window,
							bubbles: true,
							cancelable: false
						});
						linkElement.dispatchEvent(clickEvent);
					} catch (ex) {
						console.error(ex);
					}
				}
			} catch (ex) {
				console.log(ex);
				this.notification.error(ex.data);
			}
		}
	};

	loadDeclarationRndts = async () => {
		console.log('ASK FOR DATA');
		console.log(this.sens);
		this.load(true);
		console.log(this.dateDebut, this.dateFin, this.idSociete, this.idSite, this.sens);
		if (this.dateDebut && this.dateFin && this.idSociete && this.idSite) {
			this.declarationRndts = [];
			this.declarationRndtsWithMeta = {};
			var res = null;
			console.log('Selected nomenclatures on get');
			console.log(this.nomenclatures.filter((x) => x.selected).map((x) => x.id));
			try {
				if (this.sens == 0) {
					res = await this.registresService.getTexsEntrants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id)
					);
				} else if (this.sens == 1) {
					res = await this.registresService.getTexsSortants(
						this.idSociete,
						this.dateDebut,
						this.dateFin,
						this.idSite,
						this.nomenclatures.filter((x) => x.selected).map((x) => x.id)
					);
				}
				if (res) {
					this.declarationRndtsWithMeta = res;
					this.declarationRndts = res.data.content;

					console.log('this.declarationRndtsWithMeta', this.declarationRndtsWithMeta);
					console.log('this.declarationRndts', this.declarationRndts);
				} else {
					this.notification.warning('Aucun résultat');
				}
			} catch (ex) {
				console.log(ex);
				this.notification.error(ex.data);
			}
		}

		this.load(false);
	};
}
